import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../../../../common/html/button'
import { CREATE_PROFILE_TYPE } from '../constant'
import { selectCreateProfileType } from '../store/slice'
import { getProfileDefault } from '../store/thunk'

export const Reset = ({ createMode }) => {
  const dispatch = useDispatch()

  const createType = useSelector(selectCreateProfileType)

  const handleReset = () => {
    dispatch(getProfileDefault())
  }

  if (createMode && createType === CREATE_PROFILE_TYPE.FROM_EXIST) {
    return (
      <Button
        label="common.RESET"
        style={{
          border: 'none',
          backgroundColor: '#0553A5',
          color: false ? '#9C9C9C' : '#ffffff',
        }}
        disabled={false}
        action={handleReset}
        isI18n
      />
    )
  }

  return null
}
